// extracted by mini-css-extract-plugin
module.exports = {"Content":"AppLayout_Content__3npgo","Loading":"AppLayout_Loading__E0ohW","LoadingSpin":"AppLayout_LoadingSpin__34Ib_"};